module.exports = __webpack_public_path__ + "static/media/168.c77a9eab.png";